///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Tunnel, TunnelTypeEnum } from '../../../../../generated/shared-types.model';
import { NodeFeature } from '../../../../logical-topology/entities/node/node-feature';
import { GtthHistoryService } from '../../../../logical-topology/engine/history-service';
import { TunnelOffset, TunnelView } from '../../../../logical-topology/entities/tunnel/view/tunnel-view';
import { TunnelConstants } from '../../../../logical-topology/entities/tunnel/view/tunnel-view-constants';

export class TunnelModel implements Tunnel {
    id: number;
    layerIndex: number;
    tunnelNodeNames: string[];
    tunnelType: TunnelTypeEnum;
    tunnelNodes: NodeFeature[];
    color: string;
    isFiltered = true;
    isExpanded = false;

    tunnelView: TunnelView;

    tunnelOffsets: TunnelOffset[];

    tunnelOffsetsHasChanged: boolean;

    constructor(tunnel: Tunnel, historyService: GtthHistoryService) {
        this.id = tunnel.id;
        this.layerIndex = tunnel.layerIndex;
        this.tunnelType = tunnel.tunnelType;
        this.tunnelNodeNames = tunnel.tunnelNodeNames;
        this.tunnelNodes = [];
        this.tunnelNodeNames.forEach((nodeName) => {
            this.tunnelNodes.push(historyService.logicalTopology.getStationByName(nodeName));
        });
        this.tunnelOffsets = [];
    }

    isShown(): boolean {
        return this.tunnelView !== undefined;
    }

    getTunnelColor(tunnelId: number) {
        return TunnelConstants.COLORS[tunnelId % TunnelConstants.TUNNELS_QUANTITY];
    }

    draw(historyService: GtthHistoryService) {
        if (!this.tunnelView) {
            this.color = this.getTunnelColor(this.id);

            this.tunnelView = new TunnelView(
                historyService,
                this.id,
                this.color,
                this.tunnelNodes.map((node) => node.getPosition().toLatLngLiteral())
            );
            this.tunnelView.draw(this.tunnelOffsets);
        } else if (this.tunnelOffsetsHasChanged) {
            this.tunnelView.setOffsetsAndRedraw(this.tunnelOffsets);
            this.tunnelOffsetsHasChanged = false;
        }
    }

    hide() {
        if (this.tunnelView) {
            this.tunnelView.hide();
        }
        this.tunnelView = undefined;
    }

    setTunnelOffsets(newTunnelOffsets: TunnelOffset[]) {
        newTunnelOffsets.forEach((value, index) => {
            if (
                this.tunnelOffsets.length <= index ||
                this.tunnelOffsets[index].total !== newTunnelOffsets[index].total ||
                this.tunnelOffsets[index].offset !== newTunnelOffsets[index].offset
            ) {
                this.tunnelOffsetsHasChanged = true;
                this.tunnelOffsets[index] = newTunnelOffsets[index];
            }
        });
    }
}
